import {Filter} from '@/types/filter';

export const fetchNextPage = async (
  page: number,
  fetchData: (
    page: number,
    currentFilter?: Filter,
    maxResults?: number,
    companyId?: string,
    userId?: string,
    tag?: string,
    findAllEvents?: boolean,
    isPublicCompany?: boolean
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => Promise<any[]>,
  maxResults: 20,
  currentFilter?: Filter,
  companyId?: string,
  userId?: string,
  tag?: string,
  findAllEvents?: boolean,
  isPublicCompany?: boolean

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<{data: any[]; nextPage: number} | undefined> => {
  try {
    if (location) {
      const newPage = page + 1;

      const data = await fetchData(
        newPage,
        currentFilter,
        maxResults,
        companyId,
        userId,
        tag,
        findAllEvents,
        isPublicCompany
      );
      return {data, nextPage: newPage};
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
};
